import { Button, type ButtonProps, Popconfirm } from 'antd';
import { BUTTON_CONFIG } from './buttonConfig';

// import { usePermission } from "@/hooks";

interface MyButtonProps extends ButtonProps {
  onClick: () => void;
  btnType: keyof typeof BUTTON_CONFIG;
  permission?: string | string[];
}

export const MyButton: React.FC<MyButtonProps> = ({
  btnType,
  permission,
  onClick,
  children,
  ...restProps
}) => {
  const config = BUTTON_CONFIG[btnType];
  // const { permissionSet } = usePermission();

  // const allowed = checkPermission(permissionSet, permission);

  // if (!allowed && hideIfNoPermission) return null;

  const buttonNode = (
    <Button
      type={'primary'}
      icon={config.icon}
      danger={Boolean((config as any).danger)}
      onClick={config.code === 'delete' ? undefined : onClick}
      {...restProps}
    >
      {children || config.text}
    </Button>
  );

  if (config.code === 'delete') {
    return (
      <Popconfirm
        title={'确认删除？'}
        okText={'删除'}
        cancelText={'取消'}
        onConfirm={onClick}
      >
        {buttonNode}
      </Popconfirm>
    );
  }

  return buttonNode;
};
